// src/activities/cape-vr/cape-vr-views/cape-vr-files/cape-vr-form-files/InconsistenciesEvaluation.jsx

import React from 'react';
import { useFixedTForResource } from '../../../../../locales/useFixedTForResource';

function InconsistenciesEvaluation({
  vowelsInconsistency,
  setVowelsInconsistency,
  sentencesInconsistency,
  setSentencesInconsistency,
  extemporaneousSpeechInconsistency,
  setExtemporaneousSpeechInconsistency,
  inconsistencyStatus,
  setInconsistencyStatus,
}) {
  const t = useFixedTForResource('CAPEVR');

  const taskResponses = [
    ['vowels', vowelsInconsistency, setVowelsInconsistency],
    ['sentences', sentencesInconsistency, setSentencesInconsistency],
    ['extemporaneous_speech', extemporaneousSpeechInconsistency, setExtemporaneousSpeechInconsistency],
  ];

  const handleStatusChange = (status) => {
    setInconsistencyStatus(status);
    if (status === 'none') {
      taskResponses.forEach(([, response, setter]) => setter({ ...response, isPresent: false, attributeComment: '' }));
    }
  };

  return (
    <div className="capevr-radio-group">
      <label className="capevr-radio-label">{t('inconsistencies')}:</label>
      <div className="capevr-radio-buttons-and-textarea">
        {/* Radio Buttons */}
        <div className="capevr-radio-buttons">
          <label>
            <input
              type="radio"
              name="inconsistencies"
              checked={inconsistencyStatus === 'none'}
              onChange={() => handleStatusChange('none')}
            />
            {t('none')}
          </label>
          <label>
            <input
              type="radio"
              name="inconsistencies"
              checked={inconsistencyStatus === 'present'}
              onChange={() => handleStatusChange('present')}
            />
            {t('present')}
          </label>
        </div>

        {inconsistencyStatus === 'present' && taskResponses.map(([labelKey, response, setter]) => (
          <div className="capevr-textareas" key={labelKey}>
            <label className="capevr-checkbox-label-inline">
              <input
                type="checkbox"
                checked={response.isPresent}
                onChange={event => setter({
                  ...response,
                  isPresent: event.target.checked,
                  ...(!event.target.checked ? { attributeComment: '' } : {}),
                })}
              />
              {t(labelKey)}
            </label>
            {response.isPresent && <textarea
              aria-label={`${t(labelKey)} ${t('description')}`}
              value={response.attributeComment || ''}
              onChange={event => setter({ ...response, attributeComment: event.target.value })}
              placeholder={t('describe')}
              className="capevr-textarea"
            />}
          </div>
        ))}
      </div>
    </div>
  );
}

export default InconsistenciesEvaluation;
